import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { URLS } from '../../resources/constants'
import { getUser } from '../../store/user/selectors'
import { useUserApi } from '../../resources/hooks/api/userApiHook'

//import { useUserDataApi } from '../../resources/hooks/api/userDataApiHook'

import { useNavigate, useSearchParams } from 'react-router-dom';

import { resetSettings } from '../../store/settings'

import pleaseWait from '../../assets/images/loader.webp';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';




interface Props {

}

/**
 * Where to land after the SSO hand-off completes.
 *
 * The redirect target arrives in the URL, so it is untrusted input and gets the
 * one check that matters: only a same-app absolute path is honoured. A
 * protocol-relative value ("//evil.example") and a full URL
 * ("https://evil.example") are both rejected, because either would let a crafted
 * verification link bounce an authenticated user to another origin. Anything
 * rejected falls back to the dashboard, which is where this screen has always
 * sent people.
 *
 * A single leading slash is required, so "dashboard" and "" both fall back
 * rather than resolving against whatever the current path happens to be.
 */
export const destinationPath = (redirect: string | null): string => {
  const target = `${redirect || ''}`.trim();
  if (!target.startsWith('/') || target.startsWith('//') || target.includes(':')) {
    return URLS.DASHBOARD;
  }
  return target;
};
const UserVerification: React.FC<Props> = () => {

  const _users = useSelector(getUser)
  const { userAccess, fetchUserData } = useUserApi();
  const [searchParams, setSearchParams] = useSearchParams();

  const dispatch = useDispatch();

  const { i18n } = useTranslation();
  const { t } = useTranslation("scenes.userverification"); 

  const navigate = useNavigate();
  useEffect(() => {
    const params: any = {};
    if (searchParams.get('token')) {
      params['token'] = searchParams.get('token');
    }
    if (searchParams.get('dataImportOption')) {
      params['accounting_type'] = searchParams.get('dataImportOption');
    }

    i18n.changeLanguage(searchParams.get('language') || 'en');
    dispatch(resetSettings());
    userAccess(params, (message: string, resp: any) => {
      navigate(destinationPath(searchParams.get('redirect')));
    }, (error: any) => {
      console.error('UserVerification: SSO token validation failed', error);
      toast.error(
        error?.msg || error?.message || t('verificationFailed', { defaultValue: 'Sign-in link expired or already used. Please go back and try again.' })
      );
    })
  }, [])


  return (
    <>
      <div>
        <center><img src={pleaseWait} className="App-logo" alt="logo" width="50" /></center>
        <center><p><b>{t('loading')}</b></p></center>
      </div>

    </>

  )
}

export default UserVerification;